import { useParams } from "react-router-dom";
import ArtistsView from "./../components/ArtistsView.react";

export default function ArtistsViewRoute(): React$Element<any> {
  return <ArtistsView />;
}
